import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Badge from '@/components/material-ui-kit/components/Badge/Badge';
import styles from 'styles/jss/original/components/menus/detailTag';
import { IMenu } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menu: IMenu;
};

const DetailTag: React.FC<ComponentProps> = ({ menu }) => {
  const { keyword } = menu.fields;
  const classes = useStyles();

  if (!keyword || keyword.length === 0) return null;
  return (
    <div className={classes.section}>
      <h4 className={classes.title}>キーワード</h4>
      {keyword.map((item) => {
        return <Badge key={item}>{item}</Badge>;
      })}
    </div>
  );
};

export default DetailTag;
